import { useCallback, useEffect, useRef } from 'react'
import { CompositeFilterDescriptor } from '@progress/kendo-data-query'
import {
  FilterChangeEvent,
  Filter as KendoFilter,
  FilterProps as KendoFilterProps,
} from '@progress/kendo-react-data-tools'
import { isGroupedFilters } from 'utils/QueryHelpers'

interface FilterProps extends KendoFilterProps {
  onKeyDown?: (event?: KeyboardEvent) => void
}

export const Filter: React.FC<FilterProps> = (props) => {
  const ref = useRef<HTMLElement>(null)

  const handleFilterChange = (event: FilterChangeEvent) => {
    props.onChange(event)
  }

  const handleKeyFilterChange = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Enter' && props.onKeyDown) {
        props.onKeyDown(event)
      } else {
        event.stopPropagation()
      }
    },
    [props]
  )

  useEffect(() => {
    const node = ref && ref.current

    if (node) {
      node.addEventListener('keydown', handleKeyFilterChange, false)
    }

    return () => {
      if (node) {
        node.removeEventListener('keydown', handleKeyFilterChange, false)
      }
    }
  }, [handleKeyFilterChange, ref])

  return (
    <span ref={ref}>
      <KendoFilter
        value={convertFilterValue(props.value)}
        onChange={handleFilterChange}
        fields={props.fields}
      />
    </span>
  )
}

const convertFilterValue = (value: CompositeFilterDescriptor): CompositeFilterDescriptor => {
  const sortedFilters = [
    ...value.filters.filter((filter) => !isGroupedFilters(filter)),
    ...value.filters.filter((filter) => isGroupedFilters(filter)),
  ]

  return {
    logic: value.logic,
    filters: sortedFilters.map((filter) => {
      if (isGroupedFilters(filter)) {
        return convertFilterValue(filter)
      }
      return filter
    }),
  }
}
